import { adminRoutePaths } from "./adminRoutes";

export interface AdminNavigationItem {
  label: string;
  subtitle: string;
  path: string;
}

export interface AdminNavigationGroup {
  heading: string;
  items: AdminNavigationItem[];
}

// The sidebar's groups and items, in the order the admin reads them (SHELL-R4,
// SHELL-R7).
export const adminNavigation: AdminNavigationGroup[] = [
  {
    heading: "Insights",
    items: [
      { label: "Home", subtitle: "Performance and attention", path: adminRoutePaths.insightsHome },
      {
        label: "Pharmacy routing",
        subtitle: "External vs Runway",
        path: adminRoutePaths.pharmacyRouting,
      },
    ],
  },
  {
    heading: "Jobs",
    items: [
      { label: "Find", subtitle: "Users, Cases, Orders", path: adminRoutePaths.find },
      { label: "Redo", subtitle: "Cancel or replace an Order", path: adminRoutePaths.redo },
      { label: "Ship", subtitle: "Method and address", path: adminRoutePaths.ship },
    ],
  },
];

const uiKitTitle = "UI kit";
const otherScreenTitle = "Admin";

// The app bar's title on a phone: the navigation item of the open screen, "UI kit" on
// the gallery and "Admin" anywhere else (SHELL-R32).
export const adminScreenTitle = (pathname: string): string => {
  const path = pathname.replace(/(.)\/+$/, "$1");
  if (path === adminRoutePaths.uiKit) return uiKitTitle;

  const item = adminNavigation
    .flatMap((group) => group.items)
    .find((navigationItem) => navigationItem.path === path);

  return item?.label ?? otherScreenTitle;
};
